<script lang="ts">
	import { PrimaryCheckoutContext } from '#lib/websites/primary/components/PrimaryCheckoutContext/index.js';
	import { PrimaryHeader } from '#lib/websites/primary/components/PrimaryHeader/index.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<PrimaryCheckoutContext>
	<PrimaryHeader>
		{@render children?.()}
	</PrimaryHeader>
</PrimaryCheckoutContext>
